<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="sidebar">
    <div [ngClass]="{ opened: isOpened }" class="sidebar__header">
        @if (isOpened) {
            <div class="sidebar__header-item">
                <winde-ctx-sensitive-help placement="right" tooltipTextPath="projects.tree.btn.collapseAll">
                    <button (click)="collapseAll()" windeActionIcon>
                        <sui-svg-icon icon="folder" windeGrey />
                    </button>
                </winde-ctx-sensitive-help>
                <winde-ctx-sensitive-help placement="right" tooltipTextPath="projects.tree.btn.expandAll">
                    <button (click)="expandAll()" windeActionIcon>
                        <sui-svg-icon icon="folder-open" windeGrey />
                    </button>
                </winde-ctx-sensitive-help>
            </div>
        }
        <div class="sidebar_header-item">
            <winde-ctx-sensitive-help [tooltipTextPath]="'projects.tree.btn.' + (isOpened ? 'left' : 'right')" placement="right">
                <button (click)="toggleSidebar()" windeActionIcon>
                    <sui-svg-icon [icon]="isOpened ? 'caret-square-left' : 'caret-square-right'" windeGrey />
                </button>
            </winde-ctx-sensitive-help>
        </div>
    </div>
    <div [hidden]="!isOpened" class="sidebar__content">
        <div class="sidebar__content-scroll custom-scroll-bar">
            <ng-content></ng-content>
        </div>
    </div>
</div>
